import { AppwideDrawerProvider } from '@talos/kyoko';
import type { PropsWithChildren } from 'react';
import { useDisplaySettings } from './DisplaySettingsProvider';

/**
 * Ava-specific AppWideDrawer wrapper.
 *
 * Use this instead of AppwideDrawerProvider in Ava so the Show Guide toggle is
 * stored in the user's app config and survives reloads/new sessions.
 */
export function AppwideDrawerSettingsProvider({ children }: PropsWithChildren) {
  const { showAppwideDrawerGuide, setShowAppwideDrawerGuide } = useDisplaySettings();

  return (
    <AppwideDrawerProvider isGuideVisible={showAppwideDrawerGuide} setIsGuideVisible={setShowAppwideDrawerGuide}>
      {children}
    </AppwideDrawerProvider>
  );
}
